// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LayoutImagePreview__container-fc1867 {
  position: relative;
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  margin-inline-end: 16px;
  overflow: hidden;
  background-color: var(--base-30);
}

.LayoutImagePreview__video-icon-container-a1a4a2 {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--addition-40_60);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.LayoutImagePreview__video-f35587 {
  fill: var(--addition-50);
}

.LayoutImagePreview__image-cf81c8 {
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MiniatureMessageLayout/LayoutImagePreview/LayoutImagePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  margin-inline-end: 16px;\n  overflow: hidden;\n  background-color: var(--base-30);\n}\n\n.video-icon-container {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: var(--addition-40_60);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.video {\n  fill: var(--addition-50);\n}\n\n.image {\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LayoutImagePreview__container-fc1867`,
	"video-icon-container": `LayoutImagePreview__video-icon-container-a1a4a2`,
	"videoIconContainer": `LayoutImagePreview__video-icon-container-a1a4a2`,
	"video": `LayoutImagePreview__video-f35587`,
	"image": `LayoutImagePreview__image-cf81c8`
};
module.exports = ___CSS_LOADER_EXPORT___;
